import LiveProductList from '@/components/LiveProductList'
import LiveProduct from '@/components/LiveProduct'

const BagList = ({ bagItems = [] }) => {
  return (
    <LiveProductList anchor={(index) => bagItems[index]?.productId }>
      {bagItems.map((product) =>
        product
          ? <LiveProduct key={product.productId} product={product} />
          : null
      )}
    </LiveProductList>
  )
}

export default BagList
